import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Button,
  Alert,
  AlertIcon,
} from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { useIdleTimer } from 'react-idle-timer';

import { logout } from './authTokenUtils';

const WarningModal = ({
  isOpen,
  onStayLoggedIn,
  onLogout,
  finalCountdownTimeSeconds,
}: {
  isOpen: boolean;
  onLogout: () => void;
  onStayLoggedIn: () => void;
  finalCountdownTimeSeconds: number;
}) => {
  const [countdown, setCountdown] = useState(finalCountdownTimeSeconds);

  useEffect(() => {
    const interval = setInterval(() => {
      setCountdown((prev) => prev - 1);
    }, 1000);

    if (countdown <= 0) {
      onLogout();
    }

    return () => clearInterval(interval);
  }, [countdown, onLogout]);
  return (
    <Modal isOpen={isOpen} onClose={onStayLoggedIn} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Warning: Inactivity</ModalHeader>
        <ModalBody>
          <Alert status="warning">
            <AlertIcon />
            You will be logged out in {countdown} second(s)
          </Alert>
        </ModalBody>
        <ModalFooter>
          <Button colorScheme="aurora" mr={3} onClick={onStayLoggedIn}>
            Stay Logged In
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

// // warning timout popup will stay on for this must time
const finalCountdownTimeSeconds = 10; // 30 seconds

// shows WarningModal on inactivity
// resets timer on user activity
type Props = { children: React.ReactNode };
export const LogoutOnUserInactivity = ({ children }: Props) => {
  // is browser inactive
  const [isIdle, setIsIdle] = useState<boolean>(false);

  // remaining time until idle modal pops up
  const [, setRemaining] = useState<number>(0);

  const onIdle = () => {
    setIsIdle(true);
  };

  const onActive = () => {
    setIsIdle(false);
  };

  const { getRemainingTime } = useIdleTimer({
    onIdle,
    onActive,

    timeout: 10 * 60 * 1000, // 10 minutes
    crossTab: true,
    leaderElection: true,
    syncTimers: 200,
  });

  // !TODO @eldarshamukhamedov 🚩🚩🚩 Missing dependency array here, really sketchy given we're dealing
  // with a setInterval
  useEffect(() => {
    const interval = setInterval(() => {
      setRemaining(Math.ceil(getRemainingTime() / 1000));
    }, 500);

    return () => {
      clearInterval(interval);
    };
  });

  return (
    <>
      {children}
      {isIdle && (
        <WarningModal
          isOpen={isIdle}
          finalCountdownTimeSeconds={finalCountdownTimeSeconds}
          onStayLoggedIn={onActive}
          onLogout={logout}
        />
      )}
    </>
  );
};
